import { Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { Module } from "../../model/ModuleModel";
import { AbstractComponent } from '../abstract.component';
import { DescriptionDetailedGroup } from './description-detailed-group.component';

export class DescriptionDetailedModule {
    groups: DescriptionDetailedGroup[];
}

@Component({
    selector: 'description-detailed',
    template: `
        <main-title *ngIf="module.title || module.pre_title || module.sub_title" [data]="module" [moduleId]="module.id" [uniqueId]="module.unique_id"></main-title>

        <div *ngIf="module.data?.groups && module.data.groups.length > 0" class="description-detailed-groups">
            <description-detailed-group *ngFor="let group of module.data.groups" [group]="group"
                [module]="module"></description-detailed-group>
        </div>
    `,
    styleUrls: ['./description-detailed.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class DescriptionDetailedComponent extends AbstractComponent {
    @Input() override module: Module<DescriptionDetailedModule>;
    
    private static MODULE_ID: string = 'DescriptionDetailedModule';

    constructor(injector: Injector) { 
        super(injector);
    }

    getModuleId() { 
        return DescriptionDetailedComponent.MODULE_ID;
    }
}